import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { DownloadLargeReceiptComponent } from './download-large-receipt/download-large-receipt.component';
//import { AppErrorComponent } from './common/app-error/app-error.component';
import { ReceiptAuthenticationComponent } from './receipt-authentication/receipt-authentication.component';
import { DownloadAuthenticateReceiptComponent } from './download-authenticate-receipt/download-authenticate-receipt.component';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgxFileDropModule } from 'ngx-file-drop';

import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgxFileDragDropModule } from "ngx-file-drag-drop";
import { ReactiveFormsModule } from "@angular/forms";
import { ReceiptauthenticationsuccessComponent } from './receiptauthenticationsuccess/receiptauthenticationsuccess.component';
import { SidemenuComponent } from './sidemenu/sidemenu.component';
import { ContentComponent } from './content/content.component';
import { TranslateModule, TranslateLoader} from '@ngx-translate/core';
import { TranslateHttpLoader} from '@ngx-translate/http-loader';
import { AppConfigService } from './app-config.service';
import { UserSessionService } from './common/user-session.service';
import { TranslationLoaderService } from './common/translation-loader.service';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { HomepageComponent } from './homepage/homepage.component';
import { ErrorpageComponent } from './errorpage/errorpage.component';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { DefaultUrlSerializer, UrlSerializer, UrlTree } from '@angular/router';


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '../../assets/i18n/', '{lang}.json');
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    DownloadLargeReceiptComponent,
    //AppErrorComponent,
    ReceiptAuthenticationComponent,
    DownloadAuthenticateReceiptComponent,
    ReceiptauthenticationsuccessComponent,
    SidemenuComponent,
    ContentComponent,
    HomepageComponent,
    ErrorpageComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    HttpClientModule,
    NgxFileDropModule,
    BrowserModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    NgxFileDragDropModule
    ,TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: (http: HttpClient) => {
            return new TranslateHttpLoader(http, '../../assets/i18n/', '.json');
          },
          deps: [HttpClient]
      }
  })
  ,
  NgCircleProgressModule.forRoot({
    // set defaults here
    radius: 100,
    outerStrokeWidth: 16,
    innerStrokeWidth: 8,
    outerStrokeColor: "#78C000",
    innerStrokeColor: "#C7E596",
    animationDuration: 300,
  })

  ],
  providers: [AppConfigService, UserSessionService, TranslationLoaderService
    ,{
      provide:UrlSerializer,
      useClass:AppModule
    }
    
  ]
  ,exports: [
    FooterComponent,
    TranslateModule
  ],
  bootstrap: [AppComponent]
})
export class AppModule extends DefaultUrlSerializer {
  parse(url: string): UrlTree {
      // Optional Step: Do some stuff with the url if needed.

      // If you lower it in the optional step 
      // you don't need to use "toLowerCase" 
      // when you pass it down to the next function
      return super.parse(url.toLowerCase()); 
  }
}




